import { RowNode } from "../entities/rowNode";

export interface RowNodeTransaction {
  add: RowNode[];
  remove: RowNode[];
  update: RowNode[];
}
